function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#dae5ec",
  d: "M1.1 3.2v25.6h19.2v-21L16 3.2H1.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#d1dde3",
  d: "M1.1 3.3c1.2.4 2.7 1.1 3.4 2.6 1.3 2.6-1.2 4.9 0 7.7 1.1 2.6 3.9 1.8 5.3 4.5 1.4 2.8-1 5.1.1 7.5.7 1.6 3 3.1 9.7 3.2H1.1V3.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b0c5d1",
  d: "M14 8.3H8.4c-.2 0-.3-.2-.3-.3 0-.2.1-.3.3-.3H14c.2 0 .3.2.3.3.1.1-.1.3-.3.3m4.3 3.2H8.4c-.2 0-.3-.2-.3-.3s.2-.3.3-.3h9.9c.2 0 .3.2.3.3s-.1.3-.3.3m-.1 3.3H3.7c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h14.5c.2 0 .3.2.3.3 0 .1-.2.3-.3.3m.1 6.5H3.7c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h14.6c.2 0 .3.2.3.3 0 .1-.1.3-.3.3m.1 3.2H3.7c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h14.7c.2 0 .3.2.3.3s-.1.3-.3.3m-.1-6.5H3.7c-.2 0-.3-.2-.3-.3s.2-.3.3-.3h14.6c.2 0 .3.2.3.3s-.1.3-.3.3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff9271",
  d: "M29.6 22.7h-13c-.7 0-1.3-.6-1.3-1.3V14c0-.7.6-1.3 1.3-1.3h13.1c.7 0 1.3.6 1.3 1.3v7.3c0 .8-.6 1.4-1.4 1.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff744a",
  d: "M18.5 12.7h-2c-.7 0-1.3.6-1.3 1.3v7.3c0 .7.6 1.3 1.3 1.3h11.9l-9.9-9.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#414b59",
  d: "M15.2 16H31v-1.4H15.2V16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcebf",
  d: "M21.5 18.4h-4.7c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h4.7c.2 0 .3.2.3.3s-.2.3-.3.3m3.4 1.9h-8.2c-.2 0-.3-.2-.3-.3 0-.2.2-.3.3-.3h8.2c.2 0 .3.2.3.3 0 .2-.1.3-.3.3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b0c5d1",
  d: "M5.6 8.6c-.3-.1-.5-.2-.8-.2-.3 0-.5.1-.5.3 0 .3.3.3.6.4.5.1.9.3.9.8 0 .4-.3.7-.8.8v.6h-.4v-.5c-.3 0-.6-.1-.8-.2l.1-.4c.2.1.6.2.8.2.3 0 .6-.1.6-.4 0-.3-.3-.3-.6-.4-.4-.1-.9-.2-.9-.8 0-.4.3-.7.8-.8v-.4H5V8c.3 0 .5.1.7.1 0 .1-.1.5-.1.5zm10.6-5.2v4.7h4.2l-4.2-4.7z"
}));